import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import { CampaignTypes } from '../../../Codes'
import CurrencyInput from '../../../../components/form/CurrencyInput'
import AmountWarn from '../../AmountWarn'
import PropTypes from 'prop-types'
import { setMaxBiddingAmount } from '../adGroupSlice'
import { integerValue } from '../../../../utils'

const MaxBiddingAmount = ({ error }) => {
  const dispatch = useDispatch()
  const {
    campaign: {
      form: { campaignType },
    },
    adGroup: {
      form: { maxBiddingAmount, beforeMaxBiddingAmount },
    },
  } = useSelector(state => state.ad)
  const handleChange = useCallback(
    value => {
      dispatch(setMaxBiddingAmount(integerValue(value)))
    },
    [dispatch]
  )
  return (
    <div
      className={classNames('area_item', {
        error,
      })}>
      <strong className="subtit_box">
        {campaignType === CampaignTypes.TALK_CHANNEL ? (
          <>
            과금단가
            <HelpTooltip>
              1,000회당 과금되는 VAT 미포함된 금액을 의미합니다.
            </HelpTooltip>
          </>
        ) : (
          <>
            기본입찰가
            <HelpTooltip>
              입찰에 참여할 최대금액으로, VAT 미포함된 금액으로 입력하세요.
            </HelpTooltip>
          </>
        )}
      </strong>
      <div className="cont_card">
        {campaignType === CampaignTypes.TALK_CHANNEL ? (
          <p className="desc_g">
            <span className="txt_price">
              <span className="price_sale">
                <span className="screen_out">정상가</span>3,000원
              </span>
              <span className="price_induce"> → 할인가 2,000원</span>{' '}
            </span>
          </p>
        ) : (
          <div className="item_card">
            <div className="group_item">
              <CurrencyInput
                name="maxBiddingAmount"
                min={70}
                max={100000}
                step={10}
                maxLength={6}
                value={maxBiddingAmount}
                error={error}
                onValueChange={handleChange}
              />
              <AmountWarn
                before={beforeMaxBiddingAmount}
                after={maxBiddingAmount}
                error={error}
              />
            </div>
            {error ? (
              <p className="txt_error">{error}</p>
            ) : (
              <p className="desc_item">
                기본 입찰가는 최소 70원 ~ 최대 100,000원까지 10원 단위로 설정할
                수 있습니다.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
MaxBiddingAmount.propTypes = {
  error: PropTypes.string,
}
export default MaxBiddingAmount
